import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getApiUrl } from '../../api'

interface PageDetail {
  id: number
  slug: string
  title: string
  body: string | null
  is_visible: number
  sort_order: number
  created_at: string
  updated_at: string
}

export default function ContentPage() {
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()
  const [page, setPage] = useState<PageDetail | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    fetchPage()
  }, [slug])

  const fetchPage = async () => {
    setLoading(true)
    try {
      const res = await fetch(getApiUrl(`/marubit/api/page/${slug}`))
      if (!res.ok) throw new Error('조회 실패')
      setPage(await res.json())
    } catch {
      navigate('/')
    } finally {
      setLoading(false)
    }
  }

    const wrapTables = (html: string) => {
    return html
        .replace(/<table/g, '<div class="table-wrap"><table')
        .replace(/<\/table>/g, '</table></div>')
    }

  if (loading) return (
    <div className="min-h-[60vh] flex items-center justify-center text-gray-300">
      불러오는 중...
    </div>
  )

  if (!page) return null

  return (
    <div className="bg-white min-h-screen px-6 py-12">
      <div className="max-w-[1200px] mx-auto">

          <div className="mb-1">
            <h1 className="text-[26px] font-extrabold text-[#5a4035] mb-8">{page.title}</h1>
            <div className="border-b border-gray-200" />
          </div>

          {page.body && (
            <div className="pt-7 pb-4">
            <style>{`
            
                .page-content h1 { font-size: 2em; font-weight: bold; margin: 0.5em 0; }
                .page-content h2 { font-size: 1.5em; font-weight: bold; margin: 0.5em 0; }
                .page-content h1.title-line, .page-content h2.title-line { border-left: 4px solid #887267; padding-left: 10px; }
                .page-content h3 { font-size: 1.2em; font-weight: bold; margin: 0.5em 0; }
                .page-content ul { list-style-type: disc; padding-left: 1.5em; margin: 0.5em 0; overflow: hidden; }
                .page-content ol { list-style-type: decimal; padding-left: 1.5em; margin: 0.5em 0; }
                .page-content p { margin: 0.3em 0; line-height: 1.8; }
                .page-content p:empty { min-height: 1.7em; }
                .page-content td p, .page-content th p { margin: 0; }
                .page-content img { max-width: 100%; height: auto; margin: 0.5em 0; }
                .page-content hr { border: none; border-top: 1px solid #eee; margin: 1em 0; }
                .page-content strong { font-weight: bold; }
                .page-content em { font-style: italic; }
                .page-content a { color: #887267; text-decoration: underline; }
                .page-content blockquote { border: 1px solid #ddd; border-radius: 10px; padding: 12px 16px; margin: 0.8em 0; background: transparent; overflow: hidden; }
                .page-content blockquote p { margin: 0; }
                .page-content .table-wrap { overflow: hidden; margin: 0.8em 0 1.5em 0; }
                .page-content table { border-collapse: collapse; width: 100%; table-layout: fixed; }
                .page-content table td, .page-content table th { border: 1px solid #ddd; padding: 8px 12px; vertical-align: top; word-break: break-word; }
                .page-content table th { background: #f5f5f5; font-weight: bold; }
                .page-content { overflow: hidden; }
                .page-content::after { content: ''; display: table; clear: both; }
            `}</style>
            <div
              className="page-content text-[16px] text-[#333] leading-relaxed"
              dangerouslySetInnerHTML={{ __html: wrapTables(page.body) }}
            />
          </div>
        )}
      </div>
    </div>
  )
}